
import React from "react";
import { Clock, Home } from "lucide-react";
import {
  Accordion
} from "@/components/ui/accordion";
import FAQItem from "./FAQItem";

const ProcessTimingFAQ = () => {
  return (
    <div className="mb-8">
      <h3 className="text-xl font-semibold mb-4 theme-primary-text flex items-center">
        <Clock className="h-5 w-5 mr-2" />
        Quy Trình & Thời Gian
      </h3>
      <Accordion type="single" collapsible className="space-y-4">
        <FAQItem 
          value="item-4"
          icon={Clock}
          question="Bạn có thể tìm khách thuê mới cho bất động sản của tôi nhanh như thế nào?"
          answer="Trung bình, bất động sản của chúng tôi chỉ trống 15 ngày mỗi năm so với mức trung bình ngành là 43 ngày. Chúng tôi duy trì danh sách chờ khách thuê đủ điều kiện đã được sàng lọc trước và bắt đầu tiếp thị bất động sản của bạn trước khi khách thuê hiện tại chuyển đi để giảm thiểu thời gian trống."
        />
        <FAQItem 
          value="item-5"
          icon={Home}
          question="Điều gì xảy ra nếu có hư hỏng tài sản ngoài hao mòn bình thường?"
          answer="Chúng tôi tiến hành kiểm tra kỹ lưỡng khi chuyển vào và chuyển ra với tài liệu chi tiết. Nếu hư hỏng xảy ra ngoài hao mòn bình thường, chúng tôi xử lý toàn bộ quá trình tài liệu, giao tiếp với khách thuê và sửa chữa. Tiền đặt cọc bảo đảm của khách thuê và quy trình sàng lọc của chúng tôi giảm thiểu những trường hợp này."
        />
      </Accordion>
    </div>
  );
};

export default ProcessTimingFAQ;
